<template>
  <div id="Blank-Page">
    <v-container grid-list-xl fluid>
      <h1>รับพัสดุนำส่ง</h1>
    </v-container>

    <v-container fluid>
      <v-alert v-model="alert" dismissible type="success">{{ message_success }}</v-alert>
      <v-flex xs12 md4 offset-md4>
        <v-layout row>
          <v-flex md6>
            <v-text-field
              ref="parcel"
              label="รหัส กล่อง/หีบบรรจุ"
              :append-icon="parcel.Input ? 'send' : ''"
              outline
              single-line
              clearable
              v-model="parcel.Input"
              :error-messages="parcel.errorMessage"
              @click:append="parcelEnterScan"
              @keyup.enter="parcelEnterScan "
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-btn fab  @click="enbleCamera">
              <v-icon large >camera</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
               
        <p class="error">{{ error }}</p>

        <!-- <qrcode-drop-zone @decode="onDecode" @init="logErrors">
            <qrcode-stream @decode="onDecode" @init="onInit" />
          </qrcode-drop-zone>

        <qrcode-capture v-if="noStreamApiSupport" @decode="onDecode" />-->

        <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" v-if="!destroyed" />
      </v-flex>

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-for="(parcel) in parcelResult" :key="parcel.parcel_guid">
            <v-card class="mt-3">
              <v-card-title>
                <v-icon large left>drafts</v-icon>
                <span
                  class="title font-weight-light"
                >{{ parcel.cust_name }} ({{ parcel.parcel_guid }})</span>
              </v-card-title>
              <v-card-text>{{ parcel.address }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn fab icon @click="submitPickParcel(parcel.parcel_guid)">
                  <v-icon x-large title="ยืนยันนำไปส่ง">exit_to_app</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PackShipService from "@/services/PackShipService";
import authen from "@/store/modules/authen";
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "shipparcel",
  metaInfo: {
    title: "Ship Parcel"
  },
  components: {
    QrcodeStream
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
  },
  data: () => ({
    parcel: {
      input: "",
      errorMessage: ""
    },
    parcelResult: [],
    message_success: "",
    alert: false,
    noStreamApiSupport: false,
    result: "",
    error: "",
    camera: "off",
    destroyed: true,
  }),
  computed: {},
  methods: {
    ...mapActions("app", ["setTitleText"]),
    async parcelEnterScan() {
      this.parcelResult = [];
      //console.log(authen.state.userCode);
      if (!this.parcel.Input) return;

      await PackShipService.getPickParcel(this.parcel.Input)
        .then(res => {
          //console.log(res);

          if (res.success) {
            this.foundParcel = true;
            this.parcel.errorMessage = "";
            this.parcel.Input = "";
            //this.custName = res.parcels[0].cust_name;
            //this.custAddress = res.parcels[0].;
            this.parcelResult.push(res.parcel);
            //console.log(this.parcelResult);
          } else {
            this.foundParcel = false;
            this.parcel.errorMessage = res.message;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    reset() {
      this.parcel.input = "";
      this.parcelResult = [];
    },
    async submitPickParcel(id) {
      await PackShipService.submitPick(id, authen.state.userCode)
        .then(res => {
          // console.log(res);
          if (res.success) {
            this.reset();
            this.message_success = `Box id : '${id}' Pick Success`;
            this.alert = true;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    initparcel() {
      this.parcelResult = [
        {
          address: "ซอย โรงเรียนเมืองอุบล",
          parcel_guid: "JXJ1WJOWM1PNE",
          telephone: "01 8766691,2822059",
          parcel_no: 1,
          tracking_code: "",
          roworder: 30,
          messenger_pick_time: "",
          cust_code: "037039-07",
          logistic_code: "",
          messenger_code: "",
          image_guid: "",
          cust_name: "หมอวีระนัฐ และมารืสสา",
          packer_code: "001",
          parcel_drop_time: "",
          parcel_all: 2,
          packing_time: "2019-06-30 21:29:50.830936",
          ref_doc_no: "X01-IVV6201-00001",
          status: 0
        }
      ];
    },
    async onDecode(result) {
      this.result = result;
      this.parcel.input = result;

      if (result) {
        this.turnCameraOff();

        await PackShipService.getPickParcel(result)
          .then(res => {
            //console.log(res);

            if (res.success) {
              this.foundParcel = true;
              this.parcel.errorMessage = "";
              //this.parcel.Input = "";
              //this.custName = res.parcels[0].cust_name;
              //this.custAddress = res.parcels[0].;
              this.parcelResult.push(res.parcel);
              //console.log(this.parcelResult);
            } else {
              this.foundParcel = false;
              this.parcel.errorMessage = res.message;
              // this.turnCameraOn();
            }
          })
          .catch(err => {
            // eslint-disable-next-line
            console.log(err);
          });
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.noStreamApiSupport = true;
        }
      }
    },
    turnCameraOn() {
      this.reset()
      this.camera = "auto";
      this.destroyed = false;
    },
    turnCameraOff() {
      this.camera = "off";
      this.destroyed = true;
    },
    enbleCamera() {
      this.reset()
      this.camera = "auto";
      this.destroyed = false;
    },
    detectCameraCanScan() {}
  },
  mounted() {},
  created() {
    //this.detectCameraCanScan();
  }
};
</script>
